/* 示例模型 */
import item1 from '../img/example/gujianzhu.png';
import item2 from '../img/example/changbu.png';
import item3 from '../img/example/xiaobieshu.png';
import item4 from '../img/example/tianhe.png';
import item5 from '../img/example/gangjiegou.png';
import item6 from '../img/example/jidian.png';
import item7 from '../img/example/zhuangpeishi.png';
import item8 from '../img/example/shineizhuangxiu.png';

/* 首页-多格式 */
import ds from '../img/home/formats/3ds.png';
import dwg from '../img/home/formats/dwg.png';
import fbx from '../img/home/formats/fbx.png';
import ifc from '../img/home/formats/ifc.png';
import nwd from '../img/home/formats/nwd.png';
import rvt from '../img/home/formats/rvt.png';
import dgn from '../img/home/formats/dgn.png';

import moudle1 from '../img/home/safety.gif';
import moudle2 from '../img/home/highPerformance.gif';
import moudle3 from '../img/home/bigVolumes.gif';

import icon1 from '../img/home/support1.png';
import icon2 from '../img/home/support2.png';
import icon3 from '../img/home/support3.png';
import icon4 from '../img/home/support4.png';

import fullPort from '../img/home/fullPort.png';

export const modelList = [
  {
    key: 1,
    title: '小别墅.rvt',
    modeId: '5f1a4d075b289e0011b6b1c8',
    imgHref: item3,
    version:1

  },
  {
    key: 2,
    title: '钢结构.rvt',
    modeId: '5f1a4c845b289e0011b6b0f9',
    imgHref: item5,
    version:1

  },
  {
    key: 3,
    title: '室内装修.rvt',
    modeId: '5f1a4cc05b289e0011b6b175',
    imgHref: item8,
    version:1
  },
  {
    key: 4,
    title: '场布.rvt',
    modeId: '5f1a4c6a5b289e0011b6b0eb',
    imgHref: item2,
    version:1

  },
  {
    key: 5,
    title: '机电.rvt',
    modeId: '5f1a4cb85b289e0011b6b16a',
    imgHref: item6,
    version:1
  },
  {
    key: 6,
    title: '古建筑模型.rvt',
    modeId: '5f1a4c9a5b289e0011b6b142',
    imgHref: item1,
    version:1

  },
  {
    key: 7,
    title: '天河科技园.rvt',
    modeId: '5f1a4cd65b289e0011b6b1c1',
    imgHref: item4,
    version:1

  },
  {
    key: 8,
    title: '装配式.rvt',
    modeId: '5f1a4d305b289e0011b6b26a',
    imgHref: item7,
    version:1

  },
  
];

export const formats = [
  {
    key: 1,
    title: '.rvt',
    imgHref: rvt

  },
  {
    key: 2,
    title: '.dwg',
    imgHref: dwg

  },
  {
    key: 3,
    title: '.ifc',
    imgHref: ifc

  },
  {
    key: 4,
    title: '.nwd',
    imgHref: nwd

  },
  {
    key: 5,
    title: '.fbx',
    imgHref: fbx

  },
  {
    key: 6,
    title: '.3ds',
    imgHref: ds
  },
  {
    key: 7,
    title: '.dgn',
    imgHref: dgn
  }
];

//首页-(自主安全、高性能、多维度)模块
export const homeMoudleData = [
  {
      key: 1,
      title:'自主安全',
      caption:'Everybim中间件是一款完全独立自主开发，具有完全自主知识产权的BIM轻量化引擎，提供了一个简单、高效的应用二次开发，为建筑行业者提供丰富、具有价值的BIM应用。',
      image:moudle1
  },
  {
      key: 2,
      title:'高性能',
      caption:'Everybim采用多种智能算法，使得原模型在转换后的大小是原来的5%~10%，加载模型飞一般的感觉，无需web插件，无需服务器渲染，普通笔记本也能轻松打开8G的rvt模型。',
      image:moudle2
  },
  {
      key: 3,
      title:'多维度融合',
      caption:'Everybim通过2D、3D、GIS的多维度融合，从2D平面图纸与3D模型到建筑项目地理信息位置的相结合，通过多维多源数据无缝集成，为建筑行业提供决策分析。',
      image:moudle3
  },
];

//首页-轻量化
export const homeLightweight = {
    title:'轻量化',
    caption:'对BIM模型属性信息进行共享压缩存储',
    caption2:'通过参数化和引用共享的方式对几何信息进行表达',
    data:[
      {
        key:1,
        icon:icon1,
        describe:'无损轻量化算法'
      },
      {
        key:2,
        icon:icon2,
        describe:'最大化轻量化比例'
      },
      {
        key:3,
        icon:icon3,
        describe:'全端口一致性体验'
      },
      {
        key:4,
        icon:icon4,
        describe:'百万平米级流畅应用'
      }

    ]
};

//首页-多格式兼容
export const homeMultiFormat = {
  title:'多格式兼容',
  caption:'支持主流建模软件的格式无损集成，混合使用',
  formats :[
    {
      key: 1,
      title: '.rvt',
      imgHref: rvt
  
    },
    {
      key: 2,
      title: '.dwg',
      imgHref: dwg
  
    },
    {
      key: 3,
      title: '.ifc',
      imgHref: ifc
  
    },
    {
      key: 4,
      title: '.nwd',
      imgHref: nwd
  
    },
    {
      key: 5,
      title: '.fbx',
      imgHref: fbx
  
    },
    {
      key: 6,
      title: '.3ds',
      imgHref: ds
    },
    {
      key: 7,
      title: '.dgn',
      imgHref: dgn
    }
  ]
};

//首页- 全端口成熟易用
export const homeFullPort = {
  title:'成熟易用',
  caption:'凝聚数十家专业行业软件工程对接集成经验；成功服务过多种业态数十个世界级项目；支持从公有云，私有云，混合云多种形式开发部署方式；拥有完成SDK,API开发支持。',
  image:fullPort
};
